import useFirebase from "../../useFirebase";

function useDeviceStatus(deviceStatus, setDeviceStatus) {
  const { getDeviceStatus } = useFirebase();

  function getDeviceStatusData(deviceId) {
    async function getDeviceStatusMethod(deviceId) {
      const deviceStatusValue = await getDeviceStatus(deviceId);
      setDeviceStatus(deviceStatusValue?.data?.deviceStatus);
    }

    if (deviceId) getDeviceStatusMethod(deviceId);
    else return;
  }

  function fetchDeviceStatus(deviceId) {
    function getDeviceStatusMethod(deviceId) {
      return new Promise(async (resolve, reject) => {
        const deviceStatusValue = await getDeviceStatus(deviceId);
        if (deviceStatusValue?.data?.deviceStatus)
          resolve(deviceStatusValue?.data?.deviceStatus);
        else reject("DeviceStatus Not Found");
      });
    }

    if (deviceId) return getDeviceStatusMethod(deviceId);
    else return;
  }

  return {
    getDeviceStatusData,
    fetchDeviceStatus,
  };
}

export default useDeviceStatus;
